import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import useToken from 'hooks/useToken';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ReleaseNotesModal = ({ show, setShow, onDismissForever }) => {
    const { token } = useToken();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        console.log("ReleaseNotesModal rendered with show=", show);
    }, [show]);

    const handleClose = () => {
        setShow(false);
    };

    const handleDismissForever = async () => {
        setLoading(true);
        try {
            const response = await fetch('/api/account/DismissReleaseNotes', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                toast.success('Preferencia guardada. No volveremos a mostrarte esto automáticamente.');
                setShow(false);
                if (onDismissForever) {
                    onDismissForever();
                }
            } else {
                toast.error('Error al guardar preferencia');
            }
        } catch (error) {
            console.error(error);
            toast.error('Error de red al guardar preferencia');
        }
        setLoading(false);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered className="release-notes-modal">
            <Modal.Header closeButton className="border-0 pb-0 d-block text-center position-relative">
                <div className="text-center w-100 mt-2">
                    <h4 className="text-secondary fw-normal mb-2 fs-2">Akasia Software Development S.A. de C.V.</h4>
                    <div className="d-flex justify-content-center mb-2">
                        <span className="badge rounded-pill bg-primary px-3 py-2 fs--1">ADMINPANEL RELEASE NOTES</span>
                    </div>
                </div>
                <hr className="my-2 text-300 mx-lg-5" />
            </Modal.Header>
            <Modal.Body className="px-lg-5 pt-3 pb-4">
                <div className="d-flex align-items-center gap-3 mb-2 mx-lg-3">
                    <div className="bg-light rounded p-2 text-primary d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                        <FontAwesomeIcon icon="code-branch" className="fs-1 text-primary" />
                    </div>
                    <div>
                        <h4 className="mb-0 text-900 fw-bold fs-1">
                            Sprint 33 - Versión [3.1.8.6]
                        </h4>
                    </div>
                </div>
                
                <div className="d-flex align-items-center gap-2 text-600 mb-4 mx-lg-3 ps-lg-5 ms-lg-2">
                    <FontAwesomeIcon icon="calendar-alt" className="fs--1 text-500" />
                    <span className="fs--1 fw-semi-bold">23 Jul 2026</span>
                </div>

                <div className="mx-lg-3 ps-lg-5 ms-lg-2">
                    <ul className="list-unstyled">
                        <li className="d-flex align-items-start mb-3">
                            <span className="badge bg-primary me-2 mt-1 px-2 py-1 fs--2" style={{ minWidth: '90px', textAlign: 'center' }}>LOGS</span>
                            <div>
                                <strong className="text-800">[Bitácora del Sistema]</strong>{' '}
                                <span className="text-700">Se mejoraron los logs del sistema para mayor rastreabilidad y control de incidencias, optimizando el registro de eventos clave en los servidores de Akasia.</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0 px-lg-5 pb-4 justify-content-between mx-lg-3">
                <Button variant="outline-danger" className="px-3" onClick={handleDismissForever} disabled={loading}>
                    <FontAwesomeIcon icon="ban" className="me-2" />
                    {loading ? 'Guardando...' : 'No volver a mostrar'}
                </Button>
                <Button variant="primary" className="px-5" onClick={handleClose} disabled={loading}>
                    Entendido
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ReleaseNotesModal.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    onDismissForever: PropTypes.func
};

export default ReleaseNotesModal;
